import React from 'react';

export const OrderSkeleton = () => {
    return (
        <div className="order-card-wrapper" style={{ opacity: 0.8 }}>
            <div className="order-card" style={{ padding: '16px', background: '#fff', borderRadius: '12px' }}>
                {/* هدر کارت */}
                <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', paddingBottom: '12px', marginBottom: '16px' }}>
                    <div className="skeleton-box sk-title" style={{ width: '120px' }}></div>
                    <div className="skeleton-box sk-title" style={{ width: '80px' }}></div>
                </div>

                {/* بخش استپر یا محتوای میانی */}
                <div className="skeleton-box" style={{ width: '100%', height: '60px', marginBottom: '20px' }}></div>

                {/* دکمه‌های اکشن */}
                <div className="card-actions" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <div className="skeleton-box sk-btn"></div>
                    <div className="skeleton-box sk-btn"></div>
                </div>
            </div>
        </div>
    );
};
